var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppliancesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Appliances"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.69,7.5H10.69c-1.18,0-2,.98-2,2.37V30.13c0,1.4,.83,2.37,2,2.37H28.69c1.19,0,2.12-1.04,2.12-2.37V9.87c0-1.33-.93-2.37-2.12-2.37Zm-.37,22.5H11.19V10H28.32V30Z",
    style: {
      fill: "#141344"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.75,27.87c3.57,0,6.37-2.79,6.37-6.37s-2.8-6.5-6.37-6.5-6.37,2.79-6.37,6.37,2.86,6.5,6.37,6.5Zm0-10.37c2.13,0,3.87,1.83,3.87,4s-1.74,3.87-3.87,3.87-3.87-1.83-3.87-4,1.7-3.87,3.87-3.87Z",
    style: {
      fill: "#141344"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.57,12.69c.55,0,1-.45,1-1s-.45-1-1-1-1,.45-1,1,.45,1,1,1Z",
    style: {
      fill: "#141344"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.82,12.69c.55,0,1-.45,1-1s-.45-1-1-1-1,.45-1,1,.45,1,1,1Z",
    style: {
      fill: "#141344"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliancesIcon);
export default __webpack_public_path__ + "static/media/Appliances-Icon.063fb6d667de8b7b35dea8e0ff8ab8aa.svg";
export { ForwardRef as ReactComponent };